import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AIAssistantChat from './AIAssistant';

const AIAssistantToggle = () => {
  const { hasActiveSubscription, isSuperAdmin } = useAuth();
  const [isExamMode, setIsExamMode] = useState(false);

  useEffect(() => {
    // Check if we're in exam mode
    const checkExamMode = () => {
      const isExamModeActive = document.body.classList.contains('exam-mode') || 
                           document.querySelector('.exam-taking') !== null;
      setIsExamMode(isExamModeActive);
    };

    // Check periodically for exam mode changes
    const interval = setInterval(checkExamMode, 1000);
    
    return () => clearInterval(interval);
  }, []);

  // Don't render if user doesn't have active subscription (unless super admin)
  if (!hasActiveSubscription() && !isSuperAdmin()) {
    return null;
  }

  // Don't render if in exam mode
  if (isExamMode) {
    return (
      <div className="ai-assistant-exam-mode">
        <div className="exam-mode-message">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            <polyline points="8,7 16,7 16,11 8,11"/>
            <polyline points="8,13 16,13 16,17 8,17"/>
          </svg>
          <span>Focus on your exam!</span>
        </div>
      </div>
    );
  }

  return <AIAssistantChat />;
};

export default AIAssistantToggle;
